import { render, staticRenderFns } from "./merchant-nav.vue?vue&type=template&id=06cb976c&scoped=true&lang=pug&"
import script from "./merchant-nav.vue?vue&type=script&lang=js&"
export * from "./merchant-nav.vue?vue&type=script&lang=js&"
import style0 from "./merchant-nav.vue?vue&type=style&index=0&id=06cb976c&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cb976c",
  null
  
)

export default component.exports